export const COUNTRIES = [
    { code: 'AD', name: 'Andorra', nationality: 'Andorran' },
    { code: 'AE', name: 'United Arab Emirates', nationality: 'Emirati' },
    { code: 'AF', name: 'Afghanistan', nationality: 'Afghan' },
    { code: 'AG', name: 'Antigua and Barbuda', nationality: 'Antiguan/Barbudan' },
    { code: 'AI', name: 'Anguilla', nationality: 'Anguillan' },
    { code: 'AL', name: 'Albania', nationality: 'Albanian' },
    { code: 'AM', name: 'Armenia', nationality: 'Armenian' },
    { code: 'AO', name: 'Angola', nationality: 'Angolan' },
    { code: 'AQ', name: 'Antarctica', nationality: 'Antarctic' },
    { code: 'AR', name: 'Argentina', nationality: 'Argentine' },
    { code: 'AS', name: 'American Samoa', nationality: 'American Samoan' },
    { code: 'AT', name: 'Austria', nationality: 'Austrian' },
    { code: 'AU', name: 'Australia', nationality: 'Australian' },
    { code: 'AW', name: 'Aruba', nationality: 'Aruban' },
    { code: 'AX', name: 'Åland Islands', nationality: 'Ålandic' },
    { code: 'AZ', name: 'Azerbaijan', nationality: 'Azerbaijani' },
    { code: 'BA', name: 'Bosnia and Herzegovina', nationality: 'Bosnian/Herzegovinian' },
    { code: 'BB', name: 'Barbados', nationality: 'Barbadian' },
    { code: 'BD', name: 'Bangladesh', nationality: 'Bangladeshi' },
    { code: 'BE', name: 'Belgium', nationality: 'Belgian' },
    { code: 'BF', name: 'Burkina Faso', nationality: 'Burkinabé' },
    { code: 'BG', name: 'Bulgaria', nationality: 'Bulgarian' },
    { code: 'BH', name: 'Bahrain', nationality: 'Bahraini' },
    { code: 'BI', name: 'Burundi', nationality: 'Burundian' },
    { code: 'BJ', name: 'Benin', nationality: 'Beninese' },
    { code: 'BL', name: 'Saint Barthélemy', nationality: 'Saint-Barthélemois' },
    { code: 'BM', name: 'Bermuda', nationality: 'Bermudian' },
    { code: 'BN', name: 'Brunei', nationality: 'Bruneian' },
    { code: 'BO', name: 'Bolivia', nationality: 'Bolivian' },
    { code: 'BQ', name: 'Caribbean Netherlands', nationality: 'Caribbean Dutch' },
    { code: 'BR', name: 'Brazil', nationality: 'Brazilian' },
    { code: 'BS', name: 'Bahamas', nationality: 'Bahamian' },
    { code: 'BT', name: 'Bhutan', nationality: 'Bhutanese' },
    { code: 'BV', name: 'Bouvet Island', nationality: 'Norwegian' },
    { code: 'BW', name: 'Botswana', nationality: 'Botswanan' },
    { code: 'BY', name: 'Belarus', nationality: 'Belarusian' },
    { code: 'BZ', name: 'Belize', nationality: 'Belizean' },
    { code: 'CA', name: 'Canada', nationality: 'Canadian' },
    { code: 'CC', name: 'Cocos Islands', nationality: 'Cocos Islander' },
    { code: 'CD', name: 'Democratic Republic of the Congo', nationality: 'Congolese' },
    { code: 'CF', name: 'Central African Republic', nationality: 'Central African' },
    { code: 'CG', name: 'Republic of the Congo', nationality: 'Congolese' },
    { code: 'CH', name: 'Switzerland', nationality: 'Swiss' },
    { code: 'CI', name: 'Côte d\'Ivoire', nationality: 'Ivorian' },
    { code: 'CK', name: 'Cook Islands', nationality: 'Cook Islander' },
    { code: 'CL', name: 'Chile', nationality: 'Chilean' },
    { code: 'CM', name: 'Cameroon', nationality: 'Cameroonian' },
    { code: 'CN', name: 'China', nationality: 'Chinese' },
    { code: 'CO', name: 'Colombia', nationality: 'Colombian' },
    { code: 'CR', name: 'Costa Rica', nationality: 'Costa Rican' },
    { code: 'CU', name: 'Cuba', nationality: 'Cuban' },
    { code: 'CV', name: 'Cape Verde', nationality: 'Cape Verdean' },
    { code: 'CW', name: 'Curaçao', nationality: 'Curaçaoan' },
    { code: 'CX', name: 'Christmas Island', nationality: 'Christmas Islander' },
    { code: 'CY', name: 'Cyprus', nationality: 'Cypriot' },
    { code: 'CZ', name: 'Czech Republic', nationality: 'Czech' },
    { code: 'DE', name: 'Germany', nationality: 'German' },
    { code: 'DJ', name: 'Djibouti', nationality: 'Djiboutian' },
    { code: 'DK', name: 'Denmark', nationality: 'Danish' },
    { code: 'DM', name: 'Dominica', nationality: 'Dominican' },
    { code: 'DO', name: 'Dominican Republic', nationality: 'Dominican' },
    { code: 'DZ', name: 'Algeria', nationality: 'Algerian' },
    { code: 'EC', name: 'Ecuador', nationality: 'Ecuadorian' },
    { code: 'EE', name: 'Estonia', nationality: 'Estonian' },
    { code: 'EG', name: 'Egypt', nationality: 'Egyptian' },
    { code: 'EH', name: 'Western Sahara', nationality: 'Sahrawi' },
    { code: 'ER', name: 'Eritrea', nationality: 'Eritrean' },
    { code: 'ES', name: 'Spain', nationality: 'Spanish' },
    { code: 'ET', name: 'Ethiopia', nationality: 'Ethiopian' },
    { code: 'FI', name: 'Finland', nationality: 'Finnish' },
    { code: 'FJ', name: 'Fiji', nationality: 'Fijian' },
    { code: 'FK', name: 'Falkland Islands', nationality: 'Falkland Islander' },
    { code: 'FM', name: 'Micronesia', nationality: 'Micronesian' },
    { code: 'FO', name: 'Faroe Islands', nationality: 'Faroese' },
    { code: 'FR', name: 'France', nationality: 'French' },
    { code: 'GA', name: 'Gabon', nationality: 'Gabonese' },
    { code: 'GB', name: 'United Kingdom', nationality: 'British' },
    { code: 'GD', name: 'Grenada', nationality: 'Grenadian' },
    { code: 'GE', name: 'Georgia', nationality: 'Georgian' },
    { code: 'GF', name: 'French Guiana', nationality: 'French Guianese' },
    { code: 'GG', name: 'Guernsey', nationality: 'Channel Islander' },
    { code: 'GH', name: 'Ghana', nationality: 'Ghanaian' },
    { code: 'GI', name: 'Gibraltar', nationality: 'Gibraltarian' },
    { code: 'GL', name: 'Greenland', nationality: 'Greenlandic' },
    { code: 'GM', name: 'Gambia', nationality: 'Gambian' },
    { code: 'GN', name: 'Guinea', nationality: 'Guinean' },
    { code: 'GP', name: 'Guadeloupe', nationality: 'Guadeloupian' },
    { code: 'GQ', name: 'Equatorial Guinea', nationality: 'Equatorial Guinean' },
    { code: 'GR', name: 'Greece', nationality: 'Greek' },
    { code: 'GS', name: 'South Georgia', nationality: 'South Georgian' },
    { code: 'GT', name: 'Guatemala', nationality: 'Guatemalan' },
    { code: 'GU', name: 'Guam', nationality: 'Guamanian' },
    { code: 'GW', name: 'Guinea-Bissau', nationality: 'Guinea-Bissauan' },
    { code: 'GY', name: 'Guyana', nationality: 'Guyanese' },
    { code: 'HK', name: 'Hong Kong', nationality: 'Hong Kongese' },
    { code: 'HM', name: 'Heard & McDonald Islands', nationality: 'Australian' },
    { code: 'HN', name: 'Honduras', nationality: 'Honduran' },
    { code: 'HR', name: 'Croatia', nationality: 'Croatian' },
    { code: 'HT', name: 'Haiti', nationality: 'Haitian' },
    { code: 'HU', name: 'Hungary', nationality: 'Hungarian' },
    { code: 'ID', name: 'Indonesia', nationality: 'Indonesian' },
    { code: 'IE', name: 'Ireland', nationality: 'Irish' },
    { code: 'IL', name: 'Israel', nationality: 'Israeli' },
    { code: 'IM', name: 'Isle of Man', nationality: 'Manx' },
    { code: 'IN', name: 'India', nationality: 'Indian' },
    { code: 'IO', name: 'British Indian Ocean Territory', nationality: 'British' },
    { code: 'IQ', name: 'Iraq', nationality: 'Iraqi' },
    { code: 'IR', name: 'Iran', nationality: 'Iranian' },
    { code: 'IS', name: 'Iceland', nationality: 'Icelandic' },
    { code: 'IT', name: 'Italy', nationality: 'Italian' },
    { code: 'JE', name: 'Jersey', nationality: 'Channel Islander' },
    { code: 'JM', name: 'Jamaica', nationality: 'Jamaican' },
    { code: 'JO', name: 'Jordan', nationality: 'Jordanian' },
    { code: 'JP', name: 'Japan', nationality: 'Japanese' },
    { code: 'KE', name: 'Kenya', nationality: 'Kenyan' },
    { code: 'KG', name: 'Kyrgyzstan', nationality: 'Kyrgyz' },
    { code: 'KH', name: 'Cambodia', nationality: 'Cambodian' },
    { code: 'KI', name: 'Kiribati', nationality: 'I-Kiribati' },
    { code: 'KM', name: 'Comoros', nationality: 'Comorian' },
    { code: 'KN', name: 'Saint Kitts and Nevis', nationality: 'Kittitian/Nevisian' },
    { code: 'KP', name: 'North Korea', nationality: 'North Korean' },
    { code: 'KR', name: 'South Korea', nationality: 'South Korean' },
    { code: 'KW', name: 'Kuwait', nationality: 'Kuwaiti' },
    { code: 'KY', name: 'Cayman Islands', nationality: 'Caymanian' },
    { code: 'KZ', name: 'Kazakhstan', nationality: 'Kazakhstani' },
    { code: 'LA', name: 'Laos', nationality: 'Laotian' },
    { code: 'LB', name: 'Lebanon', nationality: 'Lebanese' },
    { code: 'LC', name: 'Saint Lucia', nationality: 'Saint Lucian' },
    { code: 'LI', name: 'Liechtenstein', nationality: 'Liechtensteiner' },
    { code: 'LK', name: 'Sri Lanka', nationality: 'Sri Lankan' },
    { code: 'LR', name: 'Liberia', nationality: 'Liberian' },
    { code: 'LS', name: 'Lesotho', nationality: 'Basotho' },
    { code: 'LT', name: 'Lithuania', nationality: 'Lithuanian' },
    { code: 'LU', name: 'Luxembourg', nationality: 'Luxembourgish' },
    { code: 'LV', name: 'Latvia', nationality: 'Latvian' },
    { code: 'LY', name: 'Libya', nationality: 'Libyan' },
    { code: 'MA', name: 'Morocco', nationality: 'Moroccan' },
    { code: 'MC', name: 'Monaco', nationality: 'Monégasque' },
    { code: 'MD', name: 'Moldova', nationality: 'Moldovan' },
    { code: 'ME', name: 'Montenegro', nationality: 'Montenegrin' },
    { code: 'MF', name: 'Saint Martin', nationality: 'Saint-Martinoise' },
    { code: 'MG', name: 'Madagascar', nationality: 'Malagasy' },
    { code: 'MH', name: 'Marshall Islands', nationality: 'Marshallese' },
    { code: 'MK', name: 'North Macedonia', nationality: 'Macedonian' },
    { code: 'ML', name: 'Mali', nationality: 'Malian' },
    { code: 'MM', name: 'Myanmar', nationality: 'Burmese' },
    { code: 'MN', name: 'Mongolia', nationality: 'Mongolian' },
    { code: 'MO', name: 'Macao', nationality: 'Macanese' },
    { code: 'MP', name: 'Northern Mariana Islands', nationality: 'Northern Marianan' },
    { code: 'MQ', name: 'Martinique', nationality: 'Martinican' },
    { code: 'MR', name: 'Mauritania', nationality: 'Mauritanian' },
    { code: 'MS', name: 'Montserrat', nationality: 'Montserratian' },
    { code: 'MT', name: 'Malta', nationality: 'Maltese' },
    { code: 'MU', name: 'Mauritius', nationality: 'Mauritian' },
    { code: 'MV', name: 'Maldives', nationality: 'Maldivian' },
    { code: 'MW', name: 'Malawi', nationality: 'Malawian' },
    { code: 'MX', name: 'Mexico', nationality: 'Mexican' },
    { code: 'MY', name: 'Malaysia', nationality: 'Malaysian' },
    { code: 'MZ', name: 'Mozambique', nationality: 'Mozambican' },
    { code: 'NA', name: 'Namibia', nationality: 'Namibian' },
    { code: 'NC', name: 'New Caledonia', nationality: 'New Caledonian' },
    { code: 'NE', name: 'Niger', nationality: 'Nigerien' },
    { code: 'NF', name: 'Norfolk Island', nationality: 'Norfolk Islander' },
    { code: 'NG', name: 'Nigeria', nationality: 'Nigerian' },
    { code: 'NI', name: 'Nicaragua', nationality: 'Nicaraguan' },
    { code: 'NL', name: 'Netherlands', nationality: 'Dutch' },
    { code: 'NO', name: 'Norway', nationality: 'Norwegian' },
    { code: 'NP', name: 'Nepal', nationality: 'Nepalese' },
    { code: 'NR', name: 'Nauru', nationality: 'Nauruan' },
    { code: 'NU', name: 'Niue', nationality: 'Niuean' },
    { code: 'NZ', name: 'New Zealand', nationality: 'New Zealander' },
    { code: 'OM', name: 'Oman', nationality: 'Omani' },
    { code: 'PA', name: 'Panama', nationality: 'Panamanian' },
    { code: 'PE', name: 'Peru', nationality: 'Peruvian' },
    { code: 'PF', name: 'French Polynesia', nationality: 'French Polynesian' },
    { code: 'PG', name: 'Papua New Guinea', nationality: 'Papua New Guinean' },
    { code: 'PH', name: 'Philippines', nationality: 'Filipino' },
    { code: 'PK', name: 'Pakistan', nationality: 'Pakistani' },
    { code: 'PL', name: 'Poland', nationality: 'Polish' },
    { code: 'PM', name: 'Saint Pierre and Miquelon', nationality: 'Saint-Pierrais/Miquelonnais' },
    { code: 'PN', name: 'Pitcairn Islands', nationality: 'Pitcairn Islander' },
    { code: 'PR', name: 'Puerto Rico', nationality: 'Puerto Rican' },
    { code: 'PS', name: 'Palestine', nationality: 'Palestinian' },
    { code: 'PT', name: 'Portugal', nationality: 'Portuguese' },
    { code: 'PW', name: 'Palau', nationality: 'Palauan' },
    { code: 'PY', name: 'Paraguay', nationality: 'Paraguayan' },
    { code: 'QA', name: 'Qatar', nationality: 'Qatari' },
    { code: 'RE', name: 'Réunion', nationality: 'Réunionese' },
    { code: 'RO', name: 'Romania', nationality: 'Romanian' },
    { code: 'RS', name: 'Serbia', nationality: 'Serbian' },
    { code: 'RU', name: 'Russia', nationality: 'Russian' },
    { code: 'RW', name: 'Rwanda', nationality: 'Rwandan' },
    { code: 'SA', name: 'Saudi Arabia', nationality: 'Saudi' },
    { code: 'SB', name: 'Solomon Islands', nationality: 'Solomon Islander' },
    { code: 'SC', name: 'Seychelles', nationality: 'Seychellois' },
    { code: 'SD', name: 'Sudan', nationality: 'Sudanese' },
    { code: 'SE', name: 'Sweden', nationality: 'Swedish' },
    { code: 'SG', name: 'Singapore', nationality: 'Singaporean' },
    { code: 'SH', name: 'Saint Helena', nationality: 'Saint Helenian' },
    { code: 'SI', name: 'Slovenia', nationality: 'Slovenian' },
    { code: 'SJ', name: 'Svalbard and Jan Mayen', nationality: 'Norwegian' },
    { code: 'SK', name: 'Slovakia', nationality: 'Slovak' },
    { code: 'SL', name: 'Sierra Leone', nationality: 'Sierra Leonean' },
    { code: 'SM', name: 'San Marino', nationality: 'Sammarinese' },
    { code: 'SN', name: 'Senegal', nationality: 'Senegalese' },
    { code: 'SO', name: 'Somalia', nationality: 'Somali' },
    { code: 'SR', name: 'Suriname', nationality: 'Surinamese' },
    { code: 'SS', name: 'South Sudan', nationality: 'South Sudanese' },
    { code: 'ST', name: 'São Tomé and Príncipe', nationality: 'São Toméan' },
    { code: 'SV', name: 'El Salvador', nationality: 'Salvadoran' },
    { code: 'SX', name: 'Sint Maarten', nationality: 'Sint Maartener' },
    { code: 'SY', name: 'Syria', nationality: 'Syrian' },
    { code: 'SZ', name: 'Eswatini', nationality: 'Swazi' },
    { code: 'TC', name: 'Turks and Caicos Islands', nationality: 'Turks and Caicos Islander' },
    { code: 'TD', name: 'Chad', nationality: 'Chadian' },
    { code: 'TF', name: 'French Southern Territories', nationality: 'French' },
    { code: 'TG', name: 'Togo', nationality: 'Togolese' },
    { code: 'TH', name: 'Thailand', nationality: 'Thai' },
    { code: 'TJ', name: 'Tajikistan', nationality: 'Tajik' },
    { code: 'TK', name: 'Tokelau', nationality: 'Tokelauan' },
    { code: 'TL', name: 'Timor-Leste', nationality: 'East Timorese' },
    { code: 'TM', name: 'Turkmenistan', nationality: 'Turkmen' },
    { code: 'TN', name: 'Tunisia', nationality: 'Tunisian' },
    { code: 'TO', name: 'Tonga', nationality: 'Tongan' },
    { code: 'TR', name: 'Turkey', nationality: 'Turkish' },
    { code: 'TT', name: 'Trinidad and Tobago', nationality: 'Trinidadian/Tobagonian' },
    { code: 'TV', name: 'Tuvalu', nationality: 'Tuvaluan' },
    { code: 'TW', name: 'Taiwan', nationality: 'Taiwanese' },
    { code: 'TZ', name: 'Tanzania', nationality: 'Tanzanian' },
    { code: 'UA', name: 'Ukraine', nationality: 'Ukrainian' },
    { code: 'UG', name: 'Uganda', nationality: 'Ugandan' },
    { code: 'UM', name: 'U.S. Minor Outlying Islands', nationality: 'American' },
    { code: 'US', name: 'United States', nationality: 'American' },
    { code: 'UY', name: 'Uruguay', nationality: 'Uruguayan' },
    { code: 'UZ', name: 'Uzbekistan', nationality: 'Uzbek' },
    { code: 'VA', name: 'Vatican City', nationality: 'Vatican' },
    { code: 'VC', name: 'Saint Vincent and the Grenadines', nationality: 'Vincentian' },
    { code: 'VE', name: 'Venezuela', nationality: 'Venezuelan' },
    { code: 'VG', name: 'British Virgin Islands', nationality: 'British Virgin Islander' },
    { code: 'VI', name: 'U.S. Virgin Islands', nationality: 'U.S. Virgin Islander' },
    { code: 'VN', name: 'Vietnam', nationality: 'Vietnamese' },
    { code: 'VU', name: 'Vanuatu', nationality: 'Vanuatuan' },
    { code: 'WF', name: 'Wallis and Futuna', nationality: 'Wallisian/Futunan' },
    { code: 'WS', name: 'Samoa', nationality: 'Samoan' },
    { code: 'YE', name: 'Yemen', nationality: 'Yemeni' },
    { code: 'YT', name: 'Mayotte', nationality: 'Mahoran' },
    { code: 'ZA', name: 'South Africa', nationality: 'South African' },
    { code: 'ZM', name: 'Zambia', nationality: 'Zambian' },
    { code: 'ZW', name: 'Zimbabwe', nationality: 'Zimbabwean' }
];

/**
 * EU/EEA + Switzerland free-movement nationalities (ISO alpha-2) — those that
 * don't need a work permit in NL. Mirrors the backend EU_FREE_MOVEMENT_CODES.
 * GB is intentionally excluded (post-Brexit). Non-EU nationalities live in the
 * dedicated Non-EU tab, so the nationality filter only offers this set.
 */
export const EU_FREE_MOVEMENT_CODES: string[] = [
    // EU-27
    'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU',
    'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE',
    // EEA (non-EU) + Switzerland
    'IS', 'LI', 'NO', 'CH',
];